// inventory.constants.js

export const RQ_GET_ALL_INVENTORY_API = {
  url: 'api/inventory/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_GET_INVENTORY_BY_ID_API = {
  url: 'api/inventory/<%= id %>/lookup',
  method: 'GET',
  auth: true,
};

export const RQ_GET_INVENTORY_BY_LOT_API = {
  url: 'api/inventory/lot/<%= lotNumber %>',
  method: 'GET',
  auth: true,
};

export const RQ_INVENTORY_BY_FILTER_API = {
  url: 'api/inventory/lookup/byfilter',
  method: 'POST',
  auth: true,
};

export const RQ_REGISTER_INVENTORY_API = {
  url: 'api/inventory/register',
  method: 'POST',
  auth: true,
};

export const RQ_ADD_INVENTORY_LOT_API = {
  url: 'api/inventory/<%= id %>/lot/add',
  method: 'POST',
  auth: true,
};

export const RQ_UPDATE_INVENTORY_API = {
  url: 'api/inventory/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
};

export const RQ_UPDATED_INVENTORY_LOT_API ={
  url: 'api/inventory/lot/<%= lotId %>',
  method: 'PUT',
  auth: true,
};

export const RQ_DELETE_INVENTORY_LOT_API = {
  url: 'api/inventory/lot/<%= lotId %>',
  method: 'DELETE',
  auth: true,
};

export const RQ_DELETE_INVENTORY_API = {
  url: 'api/inventory/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
